module.exports = __webpack_public_path__ + "media/images/icon-expand-fe2cd4b2e148c4c42e7dfa7cf50812c5.svg";